import { FC } from 'react';
import { LDUser } from 'utils/customTypes';
import MemberRow from './MemberRow';
import EmptyMembersTableBody from './EmptyMembersTableBody';

interface MembersTableBodyProps {
  learningTeamMembers: LDUser[];
  onRemoveMember: (memberId: string) => void;
}

const MembersTableBody: FC<MembersTableBodyProps> = ({
  learningTeamMembers,
  onRemoveMember,
}) => {
  const isListEmpty = learningTeamMembers.length === 0;
  if (isListEmpty) {
    return <EmptyMembersTableBody />;
  }
  return (
    <tbody>
      {learningTeamMembers.map((member, index) => {
        const isOdd = index % 2 !== 0;
        const bgColor = isOdd ? 'bg-neutral-lightest-two' : 'bg-neutral-white';
        return (
          <MemberRow
            key={member.id}
            member={member}
            bgColor={bgColor}
            onRemoveMember={onRemoveMember}
          />
        );
      })}
    </tbody>
  );
};

export default MembersTableBody;
